import type { ProjectileState } from './Projectile'

/**
 * Module-level shared reference to active projectiles.
 * Written by CombatController each frame, read by entity hit detection.
 */
export let activeProjectiles: ProjectileState[] = []

export function syncProjectiles(list: ProjectileState[]) {
  activeProjectiles = list
}
